import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Button, Col, Row } from 'react-bootstrap';

import { Utils } from '../../../../../shared/utils';
import etlService from '../../../ETL/etlService';

class EtlExportView extends Component {
    constructor(props) {
        super(props);
        this.etlService = new etlService();
        this.onExportAddressesClick = this.onExportAddressesClick.bind(this);
    }

    /**
     * Ui elements rendering
     */
    render() {
        return (
            <>
                <Row className="mt-4">
                    <Col sm={2} md={4} lg={4} className="col-4">
                        <Button
                            variant="outline-secondary"
                            sm="1"
                            size="sm"
                            onClick={this.onExportAddressesClick}
                            title="Download Addresses"
                        >
                            <FontAwesomeIcon icon={faDownload} />
                            <span className="ml-2">Download Prescription Addresses File</span>
                        </Button>
                    </Col>
                </Row>
            </>
        );
    }

    onExportAddressesClick() {
        const downloadUrl = this.etlService.getEtlAddressesDownloadUrl(this.props.customerId);
        Utils.download(downloadUrl);
    }
}
EtlExportView.propTypes = {
    customerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default EtlExportView;
